// extracted by mini-css-extract-plugin
export default {"footer":"footer-module--footer--954ee","content":"footer-module--content--90752","column":"footer-module--column--01b8b"};